import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Riwayat.css';
import { db } from '../firebase';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { UserAuth } from '../context/AuthContext';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import riwayatIcon from '../asset/riwayat-icon.png';
import { MdArrowCircleRight, MdDelete } from 'react-icons/md';
import logo from '../asset/logo.png';
import Swal from 'sweetalert2';
import { SkipButton } from '../components/SkipButton';

const Riwayat = () => {
  const [riwayat, setRiwayat] = useState([]);
  const { user } = UserAuth();

  const getRiwayat = async () => {
    try {
      if (user?.uid) {
        const userRef = doc(db, user.uid, 'Riwayat Hafalan');
        const docSnap = await getDoc(userRef);
        if (docSnap.exists()) {
          const riwayatData = docSnap.data();
          const bookmarks = riwayatData.bookmarks;
          return bookmarks;
        } else {
          console.log('Dokumen tidak ditemukan!');
        }
      }
    } catch (error) {
      console.error('Error saat mengambil data riwayat:', error);
    }
  };

  const fetchRiwayat = async () => {
    const riwayatData = await getRiwayat();
    setRiwayat(riwayatData);
  };

  useEffect(() => {
    fetchRiwayat();
  }, [user, setRiwayat]);

  const handleDelete = async (riwayat) => {
    try {
      const result = await Swal.fire({
        title: 'Konfirmasi Hapus',
        text: 'Apakah Anda yakin ingin menghapus item ini?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ya',
        cancelButtonText: 'Tidak',
      });

      if (result.isConfirmed) {
        if (user?.uid) {
          const userRef = doc(db, user.uid, 'Riwayat Hafalan');
          const docSnap = await getDoc(userRef);
          if (docSnap.exists()) {
            const riwayatData = docSnap.data();
            const bookmarks = riwayatData.bookmarks;
            const updatedBookmarks = bookmarks.filter(
              (bookmark) => bookmark.id !== riwayat.id
            );
            await updateDoc(userRef, { bookmarks: updatedBookmarks });
            setRiwayat(updatedBookmarks);
          } else {
            console.log('Dokumen tidak ditemukan!');
          }
        }
      }
    } catch (error) {
      console.error('Error saat menghapus field:', error);
    }
  };

  if (riwayat === undefined || riwayat.length === 0) {
    return (
      <div className='riwayat-container'>
        <SkipButton idName='#riwayat-content' />
        <Navbar />
        <h1>RIWAYAT HAFALAN</h1>
        <div className='riwayat__info'>
          <p id='riwayat-content'>Data Riwayat Hafalan Tidak Ditemukan</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className='riwayat-container'>
        <SkipButton idName='#riwayat-content' />
        <Navbar />
        <h1>RIWAYAT HAFALAN</h1>
        <div className='riwayat-section'>
          <div className='riwayat-content'>
            {riwayat.map((riwayat, index, arr) => (
              <div key={index} className='riwayat-data' id='riwayat-content'>
                {(index + 1) % 2 !== 0 && (
                  <>
                    <div className='gambar-kiri'></div>

                    <div className='lambang-wrapper'>
                      <div className='lambang-qurtal'>
                        <img src={riwayatIcon} alt='riwayatIcon' />
                      </div>
                      {index + 1 !== arr.length && (
                        <div className='lambang-line'></div>
                      )}
                    </div>
                  </>
                )}

                <div className='data-item'>
                  <div className='data-item-content'>
                    <div className='riwayat-detail__header'>
                      <div className='date'>
                        {riwayat.tanggal} {'('} {riwayat.waktu}
                        {')'}
                      </div>
                      <div className='data-item-content__button'>
                        <button
                          className='button-delete'
                          onClick={() => handleDelete(riwayat)}
                        >
                          <MdDelete />
                        </button>
                        <Link
                          to={`/detailSurat/${riwayat.nama_latin}/${riwayat.nomor_surat}/${riwayat.nomor_ayat}`}
                          className='button-arrow'
                        >
                          <MdArrowCircleRight />
                        </Link>
                      </div>
                    </div>
                    <hr className='riwayat-detail__barrier' />
                    <div className='riwayat-detail__content'>
                      <div className='riwayat-detail__content__wrapper'>
                        <div className='riwayat-detail__left'>
                          <p className='riwayat-detail__latin'>
                            {' '}
                            {riwayat.nama_latin}{' '}
                          </p>
                          <p className='riwayat-detail__arab'>
                            {' '}
                            {riwayat.nama_surah}{' '}
                          </p>
                        </div>
                        <p className='riwayat-detail__right'>
                          Ayat - {riwayat.nomor_ayat}
                        </p>
                      </div>
                      <div className='riwayat-detail__logo__wrapper'>
                        <img
                          src={logo}
                          alt='logo'
                          width='80px'
                          className='data-item__image'
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {(index + 1) % 2 === 0 && index + 1 !== arr.length && (
                  <>
                    <div className='lambang-wrapper'>
                      <div className='lambang-qurtal'>
                        <img src={riwayatIcon} alt='riwayatIcon' />
                      </div>
                      <div className='lambang-line'></div>
                    </div>
                    <div className='gambar-kiri'></div>
                  </>
                )}

                {index + 1 === arr.length && (index + 1) % 2 === 0 && (
                  <div className=''>
                    <div className='lambang-qurtal'>
                      <img src={riwayatIcon} alt='riwayatIcon' />
                    </div>
                  </div>
                )}

                <div className='data-item-sm'>
                  <div className='data-item-content'>
                    <div className='riwayat-detail__header'>
                      <div className='date'>
                        {riwayat.tanggal} {'('} {riwayat.waktu}
                        {')'}
                      </div>
                      <div className='data-item-content__button'>
                        <button
                          className='button-delete'
                          onClick={() => handleDelete(riwayat)}
                        >
                          <MdDelete />
                        </button>
                        <Link
                          to={`/detailSurat/${riwayat.nama_latin}/${riwayat.nomor_surat}/${riwayat.nomor_ayat}`}
                          className='button-arrow'
                        >
                          <MdArrowCircleRight />
                        </Link>
                      </div>
                    </div>
                    <hr className='riwayat-detail__barrier' />
                    <div className='riwayat-detail__content'>
                      <div className='riwayat-detail__content__wrapper'>
                        <div className='riwayat-detail__left'>
                          <p className='riwayat-detail__latin'>
                            {' '}
                            {riwayat.nama_latin}{' '}
                          </p>
                          <p className='riwayat-detail__arab'>
                            {' '}
                            {riwayat.nama_surah}{' '}
                          </p>
                        </div>
                        <p className='riwayat-detail__right'>
                          Ayat - {riwayat.nomor_ayat}
                        </p>
                      </div>
                      <div className='riwayat-detail__logo__wrapper'>
                        <img
                          src={logo}
                          alt='logo'
                          className='data-item__image'
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Riwayat;
